module.exports = __webpack_public_path__ + "static/media/ic_house.893c001e.svg";